import { createContext } from "react";

// 初始值為 null
export const AuthContext = createContext({
    user: null,
    pos:{lat:0,lng:0},
    setUser: () => {},
    setPos:() => {}
  });